angular.
module("dx.webapp.api").
factory("dxApiV1Exams", function apiV1ExamsService(
	$window,
	$http,
	$q,

	Exam
) {
	"use strict";

	var baseUrl = "/api/v1/exams";

	// Returns both exams and exam templates
	function getAllExamsById(examIds) {
		var url = baseUrl;
		var queryParams = {
			examIds: examIds,
		};

		var queryString = $window.jQuery.param(queryParams, true);

		if (queryString) {
			url += "?" + queryString;
		}

		return $http.get(url).then(function success(response) {
			if (response.status <= 0) {
				return $q.reject();
			}

			response.data = initExams(response.data);
			return response.data;
		});
	}

	function getExamsList(groupId, courseId, archived) {
		var url = baseUrl + "/list";
		var queryParams = {};

		if (groupId) {
			queryParams.groupId = groupId;
		}

		if (courseId) {
			queryParams.courseId = courseId;
		}

		if (typeof archived !== "undefined") {
			queryParams.archived = archived;
		}

		var queryString = $window.jQuery.param(queryParams);

		if (queryString) {
			url += "?" + queryString;
		}

		return $http.get(url).then(function success(response) {
			if (response.status <= 0) {
				return $q.reject();
			}

			response.data = initExams(response.data);
			return response;
		});
	}

	function examsPost(requestBody) {
		return $http.post(baseUrl, requestBody).then(function success(response) {
			response.data = new Exam(response.data);
			return response;
		});
	}

	function examsPut(examId, requestBody) {
		return $http.put(baseUrl + "/" + examId, requestBody).then(function success(response) {
			response.data = new Exam(response.data);
			return response;
		});
	}

	function hideExams(requestBody) {
		return $http.post(baseUrl + "/sethidden", requestBody).then(function success(response) {
			response.data = new Exam(response.data);
			return response;
		});
	}

	function examsProgress(examId, ravenSuppressCodes) {
		return $http.get(baseUrl + "/" + examId + "/progress", {ravenSuppressCodes: ravenSuppressCodes});
	}

	function initExams(rawExams) {
		var exams = [];

		if (!rawExams) {
			return exams;
		}

		for (var i = 0; i < rawExams.length; i++) {
			var exam = new Exam(rawExams[i]);
			exams.push(exam);
		}

		return exams;
	}

	function settingsPut(examId, settings) {
		var requestBody = settings;

		if (!Array.isArray(requestBody)) {
			requestBody = [requestBody];
		}

		return $http.put(baseUrl + "/" + examId + "/settings", requestBody);
	}

	function sharesDataGet() {
		return $http.get(baseUrl + "/shares/data");
	}

	function sharesDataPut(examId, settings) {
		return $http.put(baseUrl + "/" + examId + "/shares/data", settings);
	}

	function shareExamsRecipientsGet(examId) {
		return $http.get(baseUrl + "/" + examId + "/shares/recipients");
	}

	function shareExamsRecipientDelete(examId, userId) {
		return $http.delete(baseUrl + "/" + examId + "/shares?userId=" + userId);
	}

	function download(examId) {
		return baseUrl + "/" + examId + "/download";
	}

	function recalculate(examId) {
		return $http.post(baseUrl + "/" + examId + "/recalculate");
	}

	return {
		get: getExamsList,
		getAllById: getAllExamsById,
		post: examsPost,
		put: examsPut,
		progress: examsProgress,
		download: download,
		recalculate: recalculate,
		hide: hideExams,
		settings: {
			put: settingsPut,
		},
		shares: {
			data: {
				get: sharesDataGet,
				put: sharesDataPut,
			},
			recipients: {
				get: shareExamsRecipientsGet,
				delete: shareExamsRecipientDelete,
			},
		},
	};
});
